import ActivityTimeline from './ActivityTimeline'
import { usePublicTimeline } from '@/features/chat/phase1/usePublicTimeline'

export default function Phase1ActivityTimeline({
  assistant,
  hasArtifacts,
  streaming,
}) {
  const timeline = usePublicTimeline(
    assistant.phase1RunId,
    assistant.publicTimeline ?? [],
    streaming,
    Boolean(assistant.hasPublicTimeline),
  )
  return (
    <ActivityTimeline
      activity={assistant.activity ?? []}
      workStatus={assistant.workStatus ?? null}
      streaming={streaming}
      hasArtifacts={hasArtifacts}
      runId={assistant.phase1RunId ?? null}
      publicActivity={timeline}
      citations={assistant.citations ?? []}
      thoughtSummary={assistant.thoughtSummary ?? null}
      thoughtDetails={assistant.thoughtDetails ?? []}
      hasResponseText={Boolean(assistant.text?.trim())}
    />
  )
}
